import { defineComponent as t, createBlock as r, openBlock as a, unref as p, mergeProps as d, withCtx as m, createElementVNode as l } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconCompass",
  __name: "IconCompass",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (c, e) => (a(), r(p(s), d(n, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M16.683 8.31a.75.75 0 0 0-.993-.993l-5.5 2.5a.75.75 0 0 0-.373.373l-2.5 5.5a.75.75 0 0 0 .993.993l5.5-2.5a.75.75 0 0 0 .373-.373l2.5-5.5m-4.479 4.955-1.469-1.47L9.51 14.49l2.694-1.225m-.408-2.53 1.47 1.47L14.49 9.51l-2.694 1.225",
          "clip-rule": "evenodd"
        }, null, -1),
        l("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 1 1-16.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
